import { render, staticRenderFns } from "./ProblemRecommend.vue?vue&type=template&id=e0eea10a&scoped=true"
import script from "./ProblemRecommend.vue?vue&type=script&lang=js"
export * from "./ProblemRecommend.vue?vue&type=script&lang=js"
import style0 from "./ProblemRecommend.vue?vue&type=style&index=0&id=e0eea10a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0eea10a",
  null
  
)

export default component.exports